import {
  NO_CALENDER_VIEW_PUBLICATION,
  PublicationShortname,
} from "@src/app/auth/serviceIdentifier";
import { useTranslation } from "react-i18next";
import icTile from "src/app/assets/icons/archive.svg";
import icCalendar from "src/app/assets/icons/calender.svg";
import icClose from "src/app/assets/icons/close.svg";
import icInfo from "src/app/assets/icons/info.svg";
import useIsMounted from "src/app/hooks/useIsMounted";
import { isNlbUser } from "src/app/utils/userType";

import LogoutButton from "../LogoutButton";
import Tooltip from "../Tooltip";
import styles from "./index.module.scss";

type Props = {
  publicationId: PublicationShortname;
  handleLogout: () => void;
  openModal: () => void;
  toggleDrawer: () => void;
  toggleTileView: () => void;
  isLoggedIn: boolean;
  showTileView: boolean;
};

function Header({
  publicationId,
  handleLogout,
  isLoggedIn,
  toggleDrawer,
  toggleTileView,
  openModal,
  showTileView,
}: Props) {
  const { t } = useTranslation();
  // Defer isNlbUser() (sessionStorage) to post-mount so SSR === first render.
  const isMounted = useIsMounted();
  const isNlb = isMounted && isNlbUser();
  return (
    <div className={styles.headerContainer}>
      {showTileView ? (
        <div className={styles.closeButton}>
          <img
            className={styles.iconButton}
            src={icClose}
            alt="icon-close"
            onClick={toggleTileView}
            data-testid="infoBtn"
          />
        </div>
      ) : (
        <>
          <div>
            {isLoggedIn && !isNlb && (
              <Tooltip
                text={t("home:tooltip.Logout")}
                position="right"
                theme={publicationId}
              >
                <LogoutButton
                  theme={publicationId}
                  handleLogout={handleLogout}
                  label={t("home:nav.Logout")}
                />
              </Tooltip>
            )}
          </div>
          <div className={styles.rightSideHeader}>
            {/* Show info button only for NLB users (who see old modal) */}
            {isNlb && (
              <Tooltip
                text={t("home:tooltip.Onboarding")}
                position="bottom"
                theme={publicationId}
              >
                <img
                  className={styles.iconButton}
                  src={icInfo}
                  alt="icon-information"
                  onClick={openModal}
                  data-testid="infoBtn"
                />
              </Tooltip>
            )}
            {/* Hide calender view for non-daily publication like TABLA and BM */}
            {publicationId &&
              !NO_CALENDER_VIEW_PUBLICATION.includes(publicationId) && (
                <Tooltip
                  text={t("home:tooltip.CalenderView")}
                  position="bottom"
                  theme={publicationId}
                >
                  <button
                    type="button"
                    className={styles.navButton}
                    onClick={toggleDrawer}
                    data-testid="infoBtn"
                  >
                    <img src={icCalendar} alt="" />
                    <span className={styles.navLabel}>
                      {t("home:nav.Calendar")}
                    </span>
                  </button>
                </Tooltip>
              )}

            <Tooltip
              text={t("home:tooltip.TileView")}
              position="left"
              theme={publicationId}
            >
              {/* Anchor on the button so the ring frames icon + label. */}
              <button
                type="button"
                className={styles.navButton}
                onClick={toggleTileView}
                data-testid="drawerBtn"
                data-onboarding-highlight="archive"
              >
                <img src={icTile} alt="" />
                <span className={styles.navLabel}>{t("home:nav.Archive")}</span>
              </button>
            </Tooltip>
          </div>
        </>
      )}
    </div>
  );
}

export default Header;
